export default "/unterm2/js/webpack/webfonts/ButtonIcon-trash-active.svg";